import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { PointOfSaleService } from '../../../point-of-sale.service';
import { POINT_OF_SALE_TTL_ES } from '../../../point-of-sale.interface';
import { UpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.template';
import { IUpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.interface';
import { BranchStoreSelected } from 'src/app/pages/gestion/branch-stores/components/details/branch-store-details.component';

@Component({
  selector: 'pg-point-of-sale-update',
  templateUrl: './point-of-sale-update.component.html'
})
export class PointOfSaleUpdateComponent
  extends UpdateTemplate
  implements IUpdateTemplate
{
  branchStoreSelected = new BranchStoreSelected('Sucursal del punto de venta');
  constructor(
    private fb: FormBuilder,
    private serviceBase: PointOfSaleService
  ) {
    super(POINT_OF_SALE_TTL_ES, serviceBase);
  }

  ngOnInit() {
    const item = this.row;
    this.fg = this.fb.group({
      code: [item.code, [Validators.required]],
      seriesOfReceipts: [item.seriesOfReceipts, [Validators.required]]
    });
  }

  onSubmit() {
    this.updateItem$(this.parseData(this.fg.value));
  }

  parseData(form) {
    return {
      ...form,
      branchStoreId: this.branchStoreSelected.getId()
    };
  }

  setReadyToUpdate() {
    return this.fg.valid && this.branchStoreSelected.value;
  }
}
